import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import Fade from "@mui/material/Fade";
import classNames from "classnames/bind";
import { lazy, Suspense, useEffect, useState } from "react";
import CollapseIcon from "../../assets/collapse.svg?react";
import HelpIcon from "../../assets/help.svg?react";
import Tooltip from "../../common/components/atoms/Tooltip";
import useBoolean from "../../common/hooks/useBoolean";
import { FRAME_EVENT } from "../consts/Frame";
import EventManager from "../EventManager/EventManager";
import styles from "./HelpCenterManager.module.scss";

const cx = classNames.bind(styles);
const eventManager = EventManager.getInstance();

const HelpCenter = lazy(() => import("../../pages/Help/HelpCenter"));

/**
 * Manager Component to Talk To streamlit-react components and manage the Help Center
 * @returns
 */
export default function HelpCenterManager() {
    const [helpCenterState, setHelpCenterState] = useState({
        enabled: false,
        context: null,
    });
    const [open, toggle, setOpen] = useBoolean(true);

    useEffect(() => {
        eventManager.subscribe((type, data) => {
            switch (type) {
                case FRAME_EVENT.MANAGE_HELP: {
                    const enabled = !!data.enabled;
                    setHelpCenterState({
                        enabled,
                        context: data.context,
                    });
                    return;
                }
                case FRAME_EVENT.TOGGLE_HELP: {
                    toggle();
                    return;
                }

                default:
                    return;
            }
        });
    }, [setHelpCenterState, setOpen, toggle]);

    // if help-center is not enabled, revert the open state
    useEffect(() => {
        if (!helpCenterState.enabled) {
            // close the drawer
            setOpen(false);
        }
    }, [helpCenterState.enabled, setOpen]);

    // if help center is not enabled, we render nothing
    if (!helpCenterState.enabled) {
        return;
    }

    const classes = {
        root: cx("Drawer"),
        paper: cx("Container"),
    };

    return (
        <Drawer
            open={open}
            anchor="right"
            classes={classes}
            variant="persistent"
        >
            <Fade in={open}>
                <div className={cx("HelpCenterContainer")}>
                    <Suspense fallback={null}>
                        <HelpCenter
                            context={open ? helpCenterState.context : null}
                            onClose={toggle}
                        />
                    </Suspense>
                </div>
            </Fade>

            <Tooltip content="Help Center" placement="left">
                <Button
                    className={cx("Trigger", { Collapsed: !open })}
                    onClick={toggle}
                >
                    {open ? (
                        <CollapseIcon />
                    ) : (
                        <HelpIcon className={cx("HelpIcon")} />
                    )}
                </Button>
            </Tooltip>
        </Drawer>
    );
}
